import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PaymentErrorScreenComponent } from '@app/modules/setting/dialogs/payment-error-screen/payment-error-screen.component';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { DocumentService } from './document.service';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  private API_VAULT_BALANCE_URL = 'api/vault/balance';
  private API_VAULT_TRANSACTION_URL = 'api/vault/transaction';

  constructor(private readonly httpService: AmplifyHttpClient, private documentService: DocumentService, private dialog: MatDialog) {}

  shareFormMultipleUser(payload) {
    return this.httpService.post<any>(`api/vault/share-form-multiple-user`, payload).pipe(
      map((response) => {
        if (response.status == 200 || response.status == 201) {
          if (response?.data?.limit_exceeded) {
            const data: HttpErrorResponse = new HttpErrorResponse({ error: 'Data incorrect', status: 400 });

            this.dialog.open(PaymentErrorScreenComponent, {
              panelClass: 'full-window-dialog-2',
              autoFocus: false,
              disableClose: true,
              data: response?.data,
            });

            return this.handleAuthError(data);
          } else {
            return response.data;
          }
        } else {
          return response.data;
        }
      })
    );
  }
  shareForm(payload) {
    return this.httpService.post<any>(`api/vault/share-form`, payload).pipe(
      map((response) => {
        if (response.status == 200 || response.status == 201) {
          if (response?.data?.limit_exceeded) {
            const data: HttpErrorResponse = new HttpErrorResponse({ error: 'Data incorrect', status: 400 });

            this.dialog.open(PaymentErrorScreenComponent, {
              panelClass: 'full-window-dialog-2',
              autoFocus: false,
              disableClose: true,
              data: response?.data,
            });

            return this.handleAuthError(data);
          } else {
            return response.data;
          }
        } else {
          return response.data;
        }
      })
    );
  }
  updateFormShareMultiple(payload) {
    return this.httpService.patch<any>('api/vault/share-form-multiple-vault-user-share-id', payload).pipe(
      map((response) => {
        if (response.status == 200 || response.status == 201) {
          if (response?.data?.limit_exceeded) {
            const data: HttpErrorResponse = new HttpErrorResponse({ error: 'Data incorrect', status: 400 });

            this.dialog.open(PaymentErrorScreenComponent, {
              panelClass: 'full-window-dialog-2',
              autoFocus: false,
              disableClose: true,
              data: response?.data,
            });

            return this.handleAuthError(data);
          } else {
            return response.data;
          }
        } else {
          return response.data;
        }
      })
    );
  }
  updateFormShare(payload) {
    return this.httpService.patch<any>('api/vault/share-form', payload).pipe(
      map((response) => {
        if (response.status == 200 || response.status == 201) {
          if (response?.data?.limit_exceeded) {
            const data: HttpErrorResponse = new HttpErrorResponse({ error: 'Data incorrect', status: 400 });

            this.dialog.open(PaymentErrorScreenComponent, {
              panelClass: 'full-window-dialog-2',
              autoFocus: false,
              disableClose: true,
              data: response?.data,
            });

            return this.handleAuthError(data);
          } else {
            return response.data;
          }
        } else {
          return response.data;
        }
      })
    );
  }

  deleteFormShare(payload) {
    return this.httpService.patch('api/vault/share-form-delete', payload).pipe(map((response) => response));
  }

  getFormsSharedWithMe() {
    return this.httpService.get<any>('api/vault/share-form/me').pipe(map((response) => response.data));
  }

  getFormsSharedByMe() {
    return this.httpService.get<any>('api/vault/share-form/others').pipe(map((response) => response.data));
  }

  getAllSharedForms() {
    return this.httpService.get<any>('api/vault/share-form').pipe(map((response) => response.data));
  }

  getSharedFormUserList(formId, userId) {
    return this.httpService
      .get<any>(`api/vault/share-form-user-list/${formId}/${userId}`, null, loaderTypes.mainAnimation)
      .pipe(map((response) => response.data));
  }

  getSharedFormUserListByMultipleFormIds(formIds, userId) {
    return this.httpService
      .post<any>(`api/vault/share-form-user-list`, {
        form_ids: formIds,
        user_id: userId,
      })
      .pipe(map((response) => response.data));
  }
  shareFolder(payload) {
    return this.httpService.post<any>(`api/vault/share-folder`, payload).pipe(
      map((response) => {
        if (response.status == 200 || response.status == 201) {
          if (response?.data?.limit_exceeded) {
            const data: HttpErrorResponse = new HttpErrorResponse({ error: 'Data incorrect', status: 400 });

            this.dialog.open(PaymentErrorScreenComponent, {
              panelClass: 'full-window-dialog-2',
              autoFocus: false,
              disableClose: true,
              data: response?.data,
            });

            return this.handleAuthError(data);
          } else {
            return response.data;
          }
        } else {
          return response.data;
        }
      })
    );
  }

  updateFolderShare(payload) {
    return this.httpService.patch<any>('api/vault/share-folder', payload).pipe(
      map((response) => {
        if (response.status == 200 || response.status == 201) {
          if (response?.data?.limit_exceeded) {
            const data: HttpErrorResponse = new HttpErrorResponse({ error: 'Data incorrect', status: 400 });

            this.dialog.open(PaymentErrorScreenComponent, {
              panelClass: 'full-window-dialog-2',
              autoFocus: false,
              disableClose: true,
              data: response?.data,
            });

            return this.handleAuthError(data);
          } else {
            return response.data;
          }
        } else {
          return response.data;
        }
      })
    );
  }

  deleteFolderShare(payload) {
    return this.httpService.delete('api/vault/share-folder', payload).pipe(map((response) => response));
  }

  getFoldersSharedWithMe() {
    return this.httpService.get<any>('api/vault/share-folder/me').pipe(map((response) => response.data));
  }

  getFoldersSharedByMe() {
    return this.httpService.get<any>('api/vault/share-folder/others').pipe(map((response) => response.data));
  }

  getAllSharedFolders() {
    return this.httpService.get<any>('api/vault/share-folder').pipe(map((response) => response.data));
  }

  getSharedFolderUserList(folderId, userId, vaultId = null, mydata = false) {
    let w_id = this.documentService.getWorSpaceId();
    let url = `api/vault/share-folder-user-list/${folderId}/${userId}`;
    if (vaultId != null) {
      url = url + `?vault_id=${vaultId}`;
      if (mydata) {
        url = url + '&myData=true';
      }
    } else if (mydata) {
      url = url + '?myData=true';
      if (w_id != null) {
        url = url + `&w_id=${w_id}`;
      }
    }
    return this.httpService.get<any>(url).pipe(map((response) => response.data));
  }
  /**
   * manage errors
   * @param err
   * @returns {any}
   */
  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    throw err;
  }

  getVaultShareInformation(userId, vaultId = null, myData = false) {
    let url = `api/vault/share-information-user-list/${userId}`;
    if (vaultId != null) {
      url = url + `?vault_id=${vaultId}`;
      if (myData) {
        url = url + `&myData=true`;
      }
    } else if (myData) {
      url = url + `?myData=true`;
    }

    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  updateVaultShareInformation(payload) {
    const url = `api/vault/share-information`;
    return this.httpService.patch<any>(url, payload).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  deleteVaultShareInformation(payload) {
    const url = `api/vault/share-information-delete`;
    return this.httpService.post<any>(url, payload).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  createVaultShareInformation(payload) {
    const url = `api/vault/share-information`;
    return this.httpService.post<any>(url, payload).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  //  BALANCE FOR FORM
  getBalanceEntry(userId, vaultUserFormId, pageNumber, type?: any): Observable<any> {
    return this.httpService.get<any>(`${this.API_VAULT_BALANCE_URL}/${userId}/${vaultUserFormId}/${pageNumber}/${type}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getTypedBalanceEntry(userId, vaultUserFormId, pageNumber, type): Observable<any> {
    return this.httpService.get<any>(`${this.API_VAULT_BALANCE_URL}/${userId}/${vaultUserFormId}/${pageNumber}/${type}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createBalanceEntry(request) {
    return this.httpService.post<any>(`${this.API_VAULT_BALANCE_URL}`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateBalanceEntry(request) {
    return this.httpService.patch<any>(`${this.API_VAULT_BALANCE_URL}`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteBalanceEntry(request) {
    return this.httpService.post<any>(`${this.API_VAULT_BALANCE_URL}-delete`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  // TRANSACTION FOR FORM
  getTransactionEntry(request): Observable<any> {
    return this.httpService.post<any>('api/vault/transaction-data', request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createTransactionEntry(request) {
    return this.httpService.post<any>(`${this.API_VAULT_TRANSACTION_URL}`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateTransactionEntry(request) {
    return this.httpService.patch<any>(`${this.API_VAULT_TRANSACTION_URL}`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteTransactionEntry(request) {
    return this.httpService.post<any>(`${this.API_VAULT_TRANSACTION_URL}-delete`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getFormLinkedTransaction(userId, vaultUserFormId, pageNumber): Observable<any> {
    return this.httpService.get<any>(`${this.API_VAULT_TRANSACTION_URL}-linked/${userId}/${vaultUserFormId}/${pageNumber}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getFormsTypeUser(request, isLoader?: boolean) {
    return this.httpService.post<any>(`api/vault/forms-type-id-user`, request, isLoader ? loaderTypes.mainAnimation : loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
